export default {
  Title: 'List of Licenses',
  STT: 'No.',
  Country: 'Country',
  Domain: 'Domain',
  StartDate: 'Start Date',
  EndDate: 'End Date',
  Package: 'Package',
  ExpandTime: '{date} days until expiration',
  OverTime: 'Expired {date} days ago',
  Trial: 'Trial',
  Starter: 'Starter',
  Standard: 'Standard',
  Advanced: 'Advanced',
  Upgrade: 'Upgrade',
  Extend: 'Extend',
  PurchaseDevice: 'Purchase devices',
  UpdateInfo: 'Update information',
  LicenseInfo: 'License Info',
  CreateBranch: 'Request new branch',
  Filter: 'Filter',
  All: 'All',
  FromDate: 'From date',
  ToDate: 'To date',
  Clear: 'Clear',
  Cancel: 'Cancel',
  Total: 'Total: {number} requests',
  TotalLicenses: 'Total: {number} licenses',
  TotalLicensesRange: 'domains',
  TotalSubtotal: 'Total',
  Save: 'Save',
  Search: 'Search',
  PendingRequest:'There is a pending request already on the license. Please check again.',
  Infor: 'Information',
  NewestInvoiceDate: 'Newest invoice date',
  DayAgo: '{date} days ago',
  Today: 'Today',
  AllFilter: 'All',
  In30Days: 'Within 30 days',
  Out30Days: 'Older than 30 days',
  Partner: 'Partner',
  Status: 'Status',
  Inactive: 'Inactive',
  Active: 'Active',
  NumOfBranch: 'Number of branches',
  PartnerCountryTooltip: 'Your Partner operates in only one country. Selecting other countries may not return any results.',
  WrongCountrySelected: 'No license data for this country. Your Partner operates in only one specific country.',
  ResetToPartnerCountry: 'Reset to Partner country',
  NoLicenseData: 'No matching data found',
  PartnerRoleTooltip: 'As a Partner, you cannot change the assigned Partner.',
  ResetToDefaultRate: 'Reset to default exchange rate',
  ExchangeRateDefault: 'Default exchange rate: {rate}',
  Types: 'Types',
  Source: 'Source',
  SaleRevenue: 'Sales Revenue',
  PartnerProceeds: 'Partner Proceeds',
  MisaProceeds: 'MISA Proceeds',
  DeleteSuccess: 'Delete successfully',
  NeedApproval: 'Need Approval',
  Rejected: 'Rejected',
  Approved: 'Approved',
  By: 'by ',
  Approve: 'Approve',
  Edit: 'Edit',
  Delete: 'Delete',
  Type: 'Type',
  PurchaseExtraDevices: 'Purchase extra devices',
  Createby: 'Created by',
  TotalRange: 'requests',
  ApproveRequest: 'Approved Request',
  ApproveRequestText: 'Are you sure you want to approve this request?',
  Success: 'Update successfully',
  SuccessFail: 'Update failed',
  OtherReason: 'Orther reasons',
  AcceptDelete: 'Are you sure delete this request?',
  Failed: 'An error occurred, please try again',
  Apply: 'Apply',
  DateCreated: 'Created date',
  MerchantID: 'MID',
  Mode: 'Mode',
  Live: 'Live',
  Demo: 'Demo',
  Unknown: 'Unknown',
  Version: 'Version',
  Version1: 'Version 1 (W&D)',
  Version2: 'Version 2 (Android)',

  // Bổ sung cho LicenseList/LicenseDetail (gộp từ hardcode + i18nRequest/i18nAccountingObject)
  Selected: 'Selected',
  Branches: 'branches',
  UnselectAll: 'Unselect all',
  Export: 'Export',
  Loading: 'Loading...',
  RestaurantName: 'Restaurant Name',
  Email: 'Email',
  PhoneNumber: 'Phone Number',
  CreationDate: 'Created date',
  IncludePackage: 'Include package',
  Extra: 'Extra',
  NumberOfPOS: 'Number of POS',
  Unlimited: 'Unlimited',
  NumberOfTabletHandhelds: 'Number of Tablet/Handhelds',
  NumberOfKiosk: 'Number of Kiosk',
  OrderValue: 'Total',
  ListOfRequest: 'List of request',
  Date: 'Date',
  Action: 'Action',
  NumberOfExtraPOS: 'Number of Extra POS',
  NumberOfExtraTablet: 'Number of Extra Tablet/Handheld',
  NumberOfExtraKiosk: 'Number of Extra Kiosk',
  Creator: 'Created by',
  Approver: 'Approved by',
  Registed: 'Registed',
  UpgradeFrom: 'Upgrade from ',
  ExtendFor: 'Extended for {months} {unit}',
  PurchasePos: 'Purchased {number} POS',
  PurchaseTablet: 'Purchased {number}  Tablets/Handhelds',
  PurchaseKiosk: 'Purchased {number}  Kiosk'
};